<template>
  <section class="o-page-bottom-spacing">
    <page-header>
      <slot slot="title">{{ $t("preorder_fiche.create") }}</slot>
      <slot slot="description">
        <p></p>
      </slot>
    </page-header>
    <div class="o-wrapper o-wrapper--center">
      <form action="" class="c-form c-form--horizontal">
        <div class="u-max-700 c-form-row">
          <v-form-row>
            <v-custom-select
              v-model="Brand"
              :options="BrandsOptions"
              :error="Validate.Brand_Code"
              option-name="Name"
              option-value="Code"
              name="merk"
              search-label="Name"
              track-by="Code"
              @change="getCollection"
              :fluid="true"
              :multiple="false"
            >
              <slot slot="label">{{ $t("preorder_fiche.brand") }}</slot>
            </v-custom-select>
          </v-form-row>

          <v-form-row>
            <v-custom-select
              v-model="Collection"
              v-if="CollectionOptions.length"
              :options="CollectionOptions"
              :error="Validate.Collection_Id"
              option-name="Name"
              option-value="Id"
              name="collectie"
              search-label="Name"
              track-by="Id"
              :fluid="true"
              :multiple="false"
            >
              <slot slot="label">{{ $t("preorder_fiche.season") }}</slot>
            </v-custom-select>
          </v-form-row>

          <v-form-row>
            <v-input
              v-model="Name"
              name="fiche_naam"
              :fluid="true"
              :error="Validate.Name"
            >
              <slot slot="label">{{ $t("preorder_fiche.name") }}</slot>
            </v-input>
          </v-form-row>

          <v-form-row>
            <v-input
              v-model.number="MaximumDiscount"
              name="max_discount"
              type="number"
              :min="0"
              :max="100"
              :error="Validate.MaximumDiscount"
            >
              <slot slot="label">{{ $t("preorder_fiche.max_discount") }}</slot>
              <slot slot="suffix">%</slot>
            </v-input>
          </v-form-row>

          <v-form-row>
            <v-datepicker
              v-model="Deadline"
              :label="$t('preorder_fiche.deadline')"
              :error="Validate.Deadline"
              :fluid="true"
            ></v-datepicker>
          </v-form-row>

          <v-form-row>
            <v-select
              v-model.number="State"
              :fluid="true"
              name="status"
              :options="[
                {
                  value: '0',
                  content: $t('preorder_fiche.open'),
                  selected: true,
                },
                { value: '1', content: $t('preorder_fiche.hidden') },
                { value: '2', content: $t('preorder_fiche.closed') },
              ]"
            >
              <slot slot="label">{{ $t("preorder_fiche.state") }}:</slot>
            </v-select>
          </v-form-row>

          <v-form-row>
            <v-target-list-select
              :value="TargetSelected"
              :options="TargetOptions"
            >
            </v-target-list-select>
          </v-form-row>

          <v-form-row>
            <v-textarea v-model="SalesmanNote" :fluid="true" rows="7">
              <slot slot="label">{{
                $t("preorder_fiche.salesman_remarks")
              }}</slot>
            </v-textarea>
          </v-form-row>

          <v-form-row>
            <div class="c-form-item c-form-item--horizontal">
              <v-label></v-label>
              <button @click="submitForm" class="c-button c-button--alpha">
                {{ $t("global.next") }}
              </button>
            </div>
          </v-form-row>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import PageHeader from "@/components/common/PageHeader";

// Forms
import VTextarea from "@/components/form/Textarea";
import VInput from "@/components/form/Input";
import VSelect from "@/components/form/Select";
import VCustomSelect from "@/components/form/CustomSelect";
import VFilters from "@/components/form/filters/Filters";
import VFormRow from "@/components/form/Row";
import VLabel from "@/components/form/Label";
import VDatepicker from "@/components/form/Datepicker";
import VTargetListSelect from "@/components/form/targetList/TargetListSelect";
import VSwitch from "@/components/form/Switch";

// Store
import { mapGetters } from "vuex";

export default {
  components: {
    PageHeader,
    VTextarea,
    VSelect,
    VCustomSelect,
    VLabel,
    VInput,
    VFormRow,
    VDatepicker,
    VTargetListSelect,
    VSwitch,
  },
  data() {
    return {
      Brand: {},
      Collection: {},
      Name: "",
      MaximumDiscount: 0,
      Deadline: null,
      State: 0,
      SalesmanNote: "",
      Validate: {},
    };
  },
  computed: {
    ...mapGetters({
      BrandsOptions: "BrandsOptions",
      CollectionOptions: "CollectionOptions",
      TargetSelected: "TargetSelected",
      TargetOptions: "TargetOptions",
    }),
    PreOrderSheet() {
      return {
        Id: this.Id,
        Brand: { Code: this.Brand.Code },
        Collection: { Id: this.Collection.Id },
        Name: this.Name,
        MaximumDiscount: this.MaximumDiscount,
        Deadline: this.Deadline,
        State: this.State,
        SalesmanNote: this.SalesmanNote,
        Targets: this.TargetSelected,
      };
    },
  },
  created: function () {
    this.$store.dispatch("getTargetOptions");
    this.$store.dispatch("getBrandsOptions");
  },
  methods: {
    getCollection(value) {
      this.$store.dispatch("getCollectionsOptions", { Id: value.Code });
    },
    validateForm(response) {
      let errors = response.data.ModelState;

      // Get error data from server, and transform to vue data
      Object.keys(errors).forEach(function (key) {
        key = key.replace("model.", "");
        let vueKey = key.replace(".", "_");

        errors[vueKey] = errors["model." + key][0];
        delete errors["model." + key];
      });

      this.Validate = errors;
    },
    submitForm(e) {
      this.$store
        .dispatch("createPreOrderSheet", this.PreOrderSheet)
        .then((response) => {
          if (response.status > 300) {
            this.validateForm(response);
          } else {
            this.$router.push({
              name: "AdminPreOrdersEdit",
              params: { id: response },
            });
          }
        });
      e.preventDefault();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin/preOrders/Create.vue